var app,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

app = window.App || (window.App = {});

app.MailingListLabels = (function() {
  function MailingListLabels(selector1) {
    this.selector = selector1;
    this.preventEnterSubmit = bind(this.preventEnterSubmit, this);
    this.updateForm = bind(this.updateForm, this);
    this.update = bind(this.update, this);
    this.hide = bind(this.hide, this);
    this.show = bind(this.show, this);
    this.bind('click', 'a.chip-add', this.show);
    this.bind('click', 'span.chip .fa-times', this.remove);
    this.bind('blur', 'input[name=label]', this.update);
    this.bind('keydown', 'input[name=label]', this.preventEnterSubmit);
  }

  MailingListLabels.prototype.show = function(e) {
    e.preventDefault();
    $(this.selector + " .chip-add").hide();
    return $(this.selector + " input[name=label]").show().focus();
  };

  MailingListLabels.prototype.hide = function() {
    $(this.selector + " .chip-add").show();
    return $(this.selector + " input[name=label]").hide();
  };

  MailingListLabels.prototype.remove = function(e) {
    var form;
    e.preventDefault();
    form = $(this).closest("form");
    $(this).closest('.chip').remove();
    return this.updateForm();
  };

  MailingListLabels.prototype.update = function(e) {
    var label;
    label = $(this.selector + " input[name=label]");
    label.attr('name', 'mailing_list[preferred_labels][]');
    return this.updateForm();
  };

  MailingListLabels.prototype.updateForm = function(e) {
    var form, id;
    form = $("" + this.selector);
    id = $('.tab-pane.active')[0].id;
    return form.load(window.location.href + '.js', form.serialize() + ("&active_tab=" + id));
  };

  MailingListLabels.prototype.preventEnterSubmit = function(event) {
    if (event.keyCode === 13) {
      event.stopPropagation();
      event.preventDefault();
      return this.update();
    }
  };

  MailingListLabels.prototype.bind = function(event, selector, method) {
    return $(document).on(event, this.selector + " " + selector, method);
  };

  return MailingListLabels;

})();

new app.MailingListLabels('form[data-mailing-list-labels]');
